/** This export is automatically generated */
export const isoNow = '2026-11-02T13:53:32.584Z';
